const STORAGE_KEY = 'srisai_inventory_cart'
export const INVENTORY_CART_CHANGED_EVENT = 'srisai-inventory-cart-changed'

export type InventoryCartLines = Record<string, number>

function notifyCartChanged(): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new Event(INVENTORY_CART_CHANGED_EVENT))
}

export function readCartLines(): InventoryCartLines {
  if (typeof window === 'undefined') return {}
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return {}
    const parsed = JSON.parse(raw) as unknown
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {}
    const out: InventoryCartLines = {}
    for (const [k, v] of Object.entries(parsed as Record<string, unknown>)) {
      if (typeof k !== 'string' || k.length === 0) continue
      const n = typeof v === 'number' ? v : Number(v)
      if (Number.isFinite(n) && n > 0) out[k] = Math.floor(n)
    }
    return out
  } catch {
    return {}
  }
}

export function writeCartLines(lines: InventoryCartLines): void {
  if (typeof window === 'undefined') return
  localStorage.setItem(STORAGE_KEY, JSON.stringify(lines))
  notifyCartChanged()
}

export function clearAllCartLines(): void {
  writeCartLines({})
}

export function lineQty(inventoryId: string, lines?: InventoryCartLines): number {
  const L = lines ?? readCartLines()
  return L[inventoryId] ?? 0
}

export function totalCartQuantity(lines?: InventoryCartLines): number {
  const L = lines ?? readCartLines()
  return Object.values(L).reduce((a, b) => a + b, 0)
}

/** Set quantity; `maxStock` caps the value when provided (>0). */
export function setLineQty(
  inventoryId: string,
  qty: number,
  maxStock?: number | null
): void {
  const lines = { ...readCartLines() }
  let q = Math.max(0, Math.floor(qty))
  if (maxStock != null && Number(maxStock) > 0) {
    q = Math.min(q, Math.floor(Number(maxStock)))
  }
  if (q <= 0) delete lines[inventoryId]
  else lines[inventoryId] = q
  writeCartLines(lines)
}

export function incrementLine(inventoryId: string, maxStock?: number | null): void {
  const cur = lineQty(inventoryId)
  const cap = maxStock != null && Number(maxStock) > 0 ? Math.floor(Number(maxStock)) : undefined
  if (cap !== undefined && cur >= cap) return
  setLineQty(inventoryId, cur + 1, cap)
}
